/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useState, useContext } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import moment from 'moment-timezone';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';

import api from '../../../service/axios/api';
import FlashContext from '../../../components/contexts/FlashContext';
import Remove from '../modals/Remove';
import Edit from '../modals/Edit';

const useStyles = makeStyles({
  root: { width: '100%' },
});

const StyledTableCell = withStyles(() => ({
  head: { backgroundColor: '#303474', color: 'white' },
  body: { fontSize: 14 },
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

// eslint-disable-next-line import/prefer-default-export
export function CategoryTableRow({ docs, searchData }) {
  const { notifyError, notifySuccess } = useContext(FlashContext);
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState(null);

  const [openDelete, setOpenDelete] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);

  const [openEdit, setOpenEdit] = useState(false);
  const [loadingEdit, setLoadingEdit] = useState(false);
  const [editName, setEditName] = useState('');

  const handleMenu = event => setAnchorEl(event.currentTarget);

  const handleOpenEdit = () => {
    setEditName(docs.name || '');
    setAnchorEl(null);
    setOpenEdit(true);
  };

  const handleEdit = async () => {
    if (!editName || editName.trim().length === 0) {
      notifyError('Informe o nome da categoria');
      return;
    }
    setLoadingEdit(true);
    try {
      const { data } = await api.category.edit(docs.id, { name: editName });
      notifySuccess(data.message);
      setOpenEdit(false);
      searchData();
    } catch (error) {
      if (error.problems?.length > 0) error.problems.forEach(err => notifyError(err.msg));
      else notifyError(error.message);
    } finally {
      setLoadingEdit(false);
    }
  };

  const handleDelete = async () => {
    setLoadingDelete(true);
    try {
      const { data } = await api.category.remove(docs.id);
      notifySuccess(data.message);
      setOpenDelete(false);
      searchData();
    } catch (error) {
      if (error.problems?.length > 0) error.problems.forEach(err => notifyError(err.msg));
      else notifyError(error.message);
    } finally {
      setLoadingDelete(false);
      setAnchorEl(null);
    }
  };

  return (
    <>
      <StyledTableRow key={docs.id}>
        <StyledTableCell>{docs.id}</StyledTableCell>
        <StyledTableCell>{docs.name || '-'}</StyledTableCell>
        <StyledTableCell>
          {docs.created_at ? moment(docs.createdAt).format('DD/MM/YYYY') : '-'}
        </StyledTableCell>
        <StyledTableCell align="right">
          <MoreVertIcon
            onClick={handleMenu}
            fontSize="small"
            style={{ cursor: 'pointer' }}
          />
        </StyledTableCell>
      </StyledTableRow>

      <Menu
        id="menu-category"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem onClick={handleOpenEdit}>Editar</MenuItem>
        <MenuItem onClick={() => { setAnchorEl(null); setOpenDelete(true); }}>
          Remover
        </MenuItem>
      </Menu>

      <Remove
        openDelete={openDelete}
        setOpenDelete={setOpenDelete}
        loadingDelete={loadingDelete}
        handleDelete={handleDelete}
      />

      <Edit
        openEdit={openEdit}
        setOpenEdit={setOpenEdit}
        loadingEdit={loadingEdit}
        handleEdit={handleEdit}
        name={editName}
        setName={setEditName}
      />
    </>
  );
}